/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPingState {
  NotSent = 0,
  Sending = 1,
  Sent = 2
}
